import { useState } from "react";
import { PreTask } from "../interfaces/Task";
import Moment from 'moment';
import ConfirmationDialog from "../elements/ConfirmationDialog";
import UnifiedTaskEditor from "./PrePostShared/UnifiedTaskEditor";
import { useTranslation } from "react-i18next";

export interface PreTaskTeaserProps {
    task_id: string;
    task_language?: string;
    pretask: PreTask;
    position: number;
    deleteCallback: CallableFunction;
    updateCallback: CallableFunction;
    cloneCallback: CallableFunction;
    sortUpCallback: CallableFunction;
    sortDownCallback: CallableFunction;
    cloneAsCallback: CallableFunction;
}

export default function PreTaskTeaser(props: PreTaskTeaserProps) {
    const { t } = useTranslation();
    
    const [showConfirm, setShowConfirm] = useState(false);
    const [showEdit, setShowEdit] = useState(false);

    const handleDelete = () => {
        setShowConfirm(false);
        props.deleteCallback(props.pretask._id)
    }

    const askForConfirmation = () => {
        setShowConfirm(true);
    }

    const cancelDelete = () => {
        setShowConfirm(false);
    }

    const handleShowEdit = () => {
        setShowEdit(true);
    }

    const handleHideEdit = () => {
        setShowEdit(false);
    }

    const handleCloneAs = (id: string, direction: string) => {
        props.cloneAsCallback(id, direction);
    } 

    const handleSave = (pretask: PreTask) => {
        props.updateCallback(pretask, props.position);
        setShowEdit(false);
    }

    const handleSortUp = () => {
        props.sortUpCallback(props.position);
    }

    const handleSortDown = () => {
        props.sortDownCallback(props.position);
    }

    const handleClone = () => {
        props.cloneCallback(props.position);
    }

    const decodePretaskType = (type: string) => {
        switch (type) {
            case 'audio':
                return t('Audio');
            case 'dialog':
                return t('Written dialogue');
            case 'photo':
                return t('Photo');
            case 'speech':
                return t('Speech transcript');
            case 'text':
                return t('Text');
            case 'video':
                return t('Video');
            case 'activity':
                return t('Interaction activity');
            case 'game':
                return t('Game');
            case 'warmup':
                return t('Warm-up');
            default:
                return type;
        }
    }

    return(
        <div className={'pre-task-teaser-container ' + (props.pretask.category || 'custom') } key={ 'pre-task-' + props.pretask._id }>
            <h4>{ props.pretask.name }</h4>
            <div className="type">{ t("Type") }: { props.pretask.category ? t('category_' + props.pretask.category) : decodePretaskType(props.pretask.type || '') }</div>
            <div className="updated">{ Moment(props.pretask.updated).format('DD/MM/YYYY') }</div>
            <div className="actions">
                <a className="sort-up" onClick={ handleSortUp } title={ t("Move Up") }></a>
                <a className="sort-down" onClick={ handleSortDown } title={ t("Move Down") }></a>
                <a className="clone-link" onClick={ handleClone } title={ t("Clone pre-task") }></a>
                <a className="edit-link" onClick={ handleShowEdit } title={ t("Edit pre-task") }></a>
                <a className="delete-link" onClick={ askForConfirmation } title={ t("Delete pre-task") }></a>
            </div>
            { showConfirm &&
                <ConfirmationDialog
                    message={ t("Are you sure you want to delete the pre-task?") + '<strong>' + props.pretask.name + '</strong>?' + t("This action cannot be undone.")}
                    confirmLabel={ t("Delete") } cancelLabel={ t("Cancel") }
                    confirmCallback={ handleDelete } cancelCallback={ cancelDelete } />
            }
            { showEdit &&
                <UnifiedTaskEditor task_id={ props.task_id } phase="pre" id={ props.pretask._id }
                    task_language={ props.task_language } saveForm={ handleSave } closeForm={ handleHideEdit } />
            }
        </div>
    );
}